import { DataList } from './dataList';

export type { DataListConfig } from './interfaces';

export default DataList;
